import GoogleMap from './index'

export default {
  GoogleMap,
}
